<template>
  <WsVersion
    label="內訓公版"
    :localeMode="true"
    :id="$route.params.id"
    :modelName="modelName"
    :fields="versionFields"
    :versionModelName="versionModelName"
    :showFields="showFields"
    :titleKey="'last_version.name'"
    :editable="editable"
  ></WsVersion>
</template>

<script>
import model from "@/models/internal_training_template";
export default {
  data: () => ({
    modelName: model.modelName,
    versionFields: model.fields.last_version.fields,
    versionModelName: model.versionModelName,
    editable: true,
    showFields: [
      "locales",
      "acts",
      "updated_at",
      "updated_admin"
    ],
  }),
};
</script>